// Unpublished Work © 2020-2022 Deere & Company

import t from 'tcomb';

export const customerTypes = {
    BUSINESS: 'Business',
    BUSINESS_CONTACT: 'BusinessContact',
    INDIVIDUAL: 'Individual'
};

export const CustomerTypeLabelMapping = {
    [customerTypes.BUSINESS]: 'labels.BUSINESS',
    [customerTypes.BUSINESS_CONTACT]: 'labels.BUSINESS_CONTACT',
    [customerTypes.INDIVIDUAL]: 'labels.INDIVIDUAL'
};

export const CustomerTypeWarningLabelMapping = {
    [customerTypes.BUSINESS]: 'messages.OUT_OF_BUSINESS_REQUEST_LINK',
    [customerTypes.BUSINESS_CONTACT]: 'messages.DECEASED_OUT_OF_BUSINESS_REQUEST_LINK',
    [customerTypes.INDIVIDUAL]: 'messages.DECEASED_REQUEST_LINK'
};

export const CustomerType = t.enums.of(Object.values(customerTypes), 'CustomerType');
